export const ADMIN = 1;
export const VENDOR_MANAGER = 5;
export const STORE_MANAGER = 10;
export const STORE_PERSON = 11;

export const ADMIN_WHITELIST = [ADMIN, VENDOR_MANAGER, STORE_MANAGER];
export const ALL_ROLES = [ADMIN, VENDOR_MANAGER, STORE_MANAGER, STORE_PERSON];
